export const replaceAllFn = (string, search, replace) => {
  return string?.split(search)?.join(replace)
}

export const parsePaymentInfo = text => {
  const splittedText = text?.split('<p>')
  if (splittedText?.length > 0) {
    const description = splittedText[0]?.replace('\n', '')

    let infoText = ''

    if (splittedText[1] && splittedText?.length > 1) {
      let replacedText = splittedText[1]
        ?.replace('<p>', '')
        ?.replace('</p>', '')
        ?.replace('<strong>', '')
        ?.replace('</strong>', '')

      infoText = replacedText

      // commented for displaying text with spaces
      // replaceAllFn(replacedText, '\n', '')
    }

    return { description, infoText }
  }
}

export function closeOnOutsideClick(event, container, selectEl, shevronIcon, listenersData) {
  let target = event.target
  let insideClick = target == container || container.contains(target)
  let clickOnSelect = target == selectEl
  let menu_is_active = container.style.display === 'flex'

  if (!insideClick && !clickOnSelect && menu_is_active) {
    container.style.display = 'none'
    shevronIcon.classList.toggle('opened')
    listenersData && cleanListeners(listenersData)
  }
}

export function cleanListeners(listenersData) {
  listenersData.forEach(([elem, listener]) => {
    elem.removeEventListener('click', listener)
  })
}

export function fetchUrl(url, reqOptions = { method: 'GET' }) {
  return fetch(url, reqOptions)
    .then(async response => {
      if (!response.ok) {
        throw new Error(response.status)
      }

      const text = await response.text()
      if (!text) return null

      return JSON.parse(text)
    })
    .catch(error => {
      console.error(error)
      return error
    })
}

export function getKeyByValue(obj, value) {
  return Object.keys(obj).find(key => obj[key] === value)
}

// Reorder dedic
export function reorderConfigs(data, orderedConfigs) {
  const result = []
  const remaining = [...data]

  for (const configName of orderedConfigs) {
    const index = remaining.findIndex(item => item.config === configName)
    if (index !== -1) {
      result.push(remaining.splice(index, 1)[0])
    }
  }

  return [...result, ...remaining]
}

export function isBeforeExpiration(expirationDateString) {
  const now = new Date()
  const expiration = new Date(expirationDateString)

  // 3 is summer time (winter time is 2)
  const getKyivOffset = date => {
    const utc = date.getTime() + date.getTimezoneOffset() * 60000
    const kyivTime = new Date(utc + 3 * 3600000)
    return kyivTime
  }

  const nowKyiv = getKyivOffset(now)
  const expirationKyiv = getKyivOffset(expiration)

  return nowKyiv < expirationKyiv
}
